import { gql } from '@apollo/client';

export default class UserSettingQuery {
    static GET_EMAIL_SIGNATURE = gql`
        query getEmailSignature {
            getEmailSignature {
                userSettingId
                value
            }
        }
    `;

    static GET_ACTIVE_TRUSTED_DEVICES = gql`
        query getActiveTrustedDevices {
            getActiveTrustedDevices {
                trustedDeviceId
                userAgent
                createdOn
                expiresAt
            }
        }
    `;

    static GET_EMPLOYEE_TYPES = gql`
    query getEmployeeTypes {
        getEmployeeTypes {
            employeeTypeId
            employeeType
        }
    }
    `;
}
